import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { catchError } from 'rxjs';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class ProductDetailService {

  constructor(@Inject(PLATFORM_ID) private platformId: Object,
  public http: HttpClient, public utils: UtilsService) { }

  getDistributorsProductInfo(data: any) {
    let controller;
    const userId = localStorage.getItem('userId')
    controller = userId ? 'GetProductDetailsPage' : 'AnonymousGetProductDetailsPage'
    return this.http.post(`${this.utils.apiUrl}Product/${controller}`, data)
      .pipe(catchError(this.utils.processError.bind(this)))
}

  notifyProductAvailability(data: any) {
    return this.http.post(`${this.utils.apiUrl}Product/AddNotifyProduct`, data)
      .pipe(catchError(this.utils.processError.bind(this)))
  }

  updateWishList(data: any) {
    let url = `${this.utils.apiUrl}Product/SetWishList`
    return this.http.post(url, data)
      .pipe(catchError(this.utils.processError.bind(this)))
  }

  addRegisterProduct(data: any) {
    let url =
      this.utils.apiUrl +
      'Product/AddRegisterProduct';
    return this.http
      .post(url, data)
      .pipe(catchError(this.utils.processError.bind(this)));
  }
  requestEnquiry(data: any) {
    let url = this.utils.apiUrl + 'CustomerConsultation/B2BFormEnquiry';
    return this.http
      .post(url, data)
      .pipe(catchError(this.utils.processError.bind(this)));
  }
  generateOTP(data: any) {
    let url = this.utils.apiUrl + 'Sms/AnonymousOTPGeneration';
    return this.http
      .post(url, data)
      .pipe(catchError(this.utils.processError.bind(this)));
  }
  verifyOTP(data: any) {
    let url = this.utils.apiUrl + 'Sms/AnonymousOTPVerification';
    return this.http
      .post(url, data)
      .pipe(catchError(this.utils.processError.bind(this)));
  }
  getComboProductsVisible(data: any) {
    return this.http.get(`${this.utils.apiUrl}Product/GetComboProductsVisible?comboProductGuidId=${data}`, data)
      .pipe(catchError(this.utils.processError.bind(this)))
  }

  submitEcomDistributor(body: any) { 
    let url = `${this.utils.apiUrl}CustomerConsultation/EcomDistributorEnquiryForm`;
    return this.http.post(url, body).pipe(catchError(this.utils.processError.bind(this)));
  }
  spinWin(data: any) {
    let url = this.utils.apiUrl + 'CustomerConsultation/SpinWheel';
    return this.http
      .post(url, data)
      .pipe(catchError(this.utils.processError.bind(this)));
  }

  submitpredictwin(body: any) { 
    let url = `${this.utils.apiUrl}CustomerConsultation/PridictWinEnquiry`;
    return this.http.post(url, body).pipe(catchError(this.utils.processError.bind(this)));
  }
  validatePrizeCoupon(body: any) { 
    let url = `${this.utils.apiUrl}CustomerConsultation/GetPredictWinCoupon`;
    return this.http.post(url, body).pipe(catchError(this.utils.processError.bind(this)));
  }
}
